<template>
<div class="base-method-cards">
	<div class="base-method" data-id="7">
		<form method="post" class="login-package-card">
            <input type="hidden" id="iMethodId" name="iMethodId" value="7" />
        </form>
	</div>
	<div class="base-method" data-id="1">
		<form method="post" class="login-package-card">
            <input type="hidden" id="iMethodId" name="iMethodId" value="1" />
        </form>
	</div>
	<div class="base-method" data-id="2">
		<form method="post" class="login-package-card">
            <input type="hidden" id="iMethodId" name="iMethodId" value="2" />
        </form>
	</div>
	<div class="base-method" data-id="23">
		<form method="post" class="login-package-card">
            <input type="hidden" id="iMethodId" name="iMethodId" value="23" />
        </form>
	</div>
	<div class="base-method" data-id="25">
		<form method="post" class="login-package-card">
            <input type="hidden" id="iMethodId" name="iMethodId" value="25" />
        </form>
	</div>
	<div class="base-method" data-id="0">
		<form method="post" class="login-package-card">
			<div class="div-standard-container color-D card">
				<input type="hidden" class="sWelcomeRoom" name="sRoom" v-model="sRoom">
                <input type="hidden" class="sWelcomeFirstName" name="sFirstName" v-model="sFirstName">
                <input type="hidden" class="sWelcomeLastName" name="sLastName" v-model="sLastName">
				<div class="auth-zone conference">
					<input type="hidden" id="iMethodId" name="iMethodId" value="7" />
				</div>
				<div class="auth-zone backofhouse">
					<input type="hidden" id="iMethodId" name="iMethodId" value="7" />
				</div>
				<div class="auth-zone publicspace">
					<div class="auth-zone-method" data-id="7">
						<input type="hidden" id="iMethodId" name="iMethodId" value="7" />
					</div>
					<div class="auth-zone-method" data-id="1">
						<input type="hidden" id="iMethodId" name="iMethodId" value="1" />
					</div>
					<div class="auth-zone-method" data-id="2">
						<input type="hidden" id="iMethodId" name="iMethodId" value="2" />
					</div>
					<div class="auth-zone-method" data-id="23">
						<input type="hidden" id="iMethodId" name="iMethodId" value="23" />
					</div>
					<div class="auth-zone-method" data-id="25">
						<input type="hidden" id="iMethodId" name="iMethodId" value="25" />
					</div>
				</div>
				<div class="font-E color-A card-header">
                    <span style="margin: auto;">
                        <% VAR(aCustomVars[basicPackageName]) %>
                        <% IF(VAR(aCustomVars[basicPackageNameForDetails])!='') %>
                        <br />
                        <span style="margin: auto; font-size: .5em;">
                            <% VAR(aCustomVars[basicPackageNameForDetails]) %>
                        </span>
                        <% IF_END() %>
                    </span>
                </div>
                <div class="connectscreen_4.1">
                	<div class="color-A card-triangle"></div>
                </div>
                <div class="error_text">
                	<div style="height:10px;"></div>
                    <div class="error-message">
                        <div class="headline">Please correct the following and try again.</div>
                        <br />
                        <div class="error-body"><% VAR(error_text) %></div>
                    </div>
                </div>
                <div class="connectscreen_4.1">
                	<BaseMethodCardPricing></BaseMethodCardPricing>
                    <BaseMethodCardInfo></BaseMethodCardInfo>
                    <BaseMethodCardDuration></BaseMethodCardDuration>

                	<div class="connect-button-wrapper" style="">
                        <input type="hidden" name="guest_duration_by_checkout" id="guest_duration_by_checkout" value="" />
                        <button class="button-0 font-E color-A connect-button">connect now</button>
                    </div>
                </div>
                <div class="default">
                	<BaseMethodCardInfo></BaseMethodCardInfo>
                    <div class="font-D-container non-mobile package-info-wrapper" style="">
                        &nbsp;<!-- free for Rewards members* -->
                    </div>
                    <hr class="non-mobile" /><!--<br class="mobile" />-->
                    <BaseMethodCardPricing></BaseMethodCardPricing>
                    <hr class="non-mobile" />
                    <BaseMethodCardDuration></BaseMethodCardDuration>


                    <div class="radisson_red">
	                    <div id="radisson-red-tos-checkbox-wrapper" style="margin-bottom: 0;">
	                        <input type="checkbox" value="1" id="radisson-red-tos-checkbox" />
	                        <label for="radisson-red-tos-checkbox" class="radisson-red-tos-label">
	                            I agree with the T's and C's <b style="color:#e62428;">*</b>
	                        </label>
	                    </div>
	                </div>
                    <div class="connect-button-wrapper" style="">
                        <input type="hidden" name="guest_duration_by_checkout" id="guest_duration_by_checkout" value="" />
                        <button class="button-0 font-E color-A connect-button">connect</button>
                    </div>
                </div>
			</div>
		</form>
	</div>
</div>
</template>

<script>

export default {
  name: "BaseMethodCards"
}

</script>

<style scoped>

</style>